import { createApi } from "@reduxjs/toolkit/query/react";
import { appendFormData } from "helpers/functions";
import customFetchBase from "services/principal/customFetchBase";

export const cargoApi = createApi({
  reducerPath: "cargoApi",
  baseQuery: customFetchBase,
  tagTypes: ["Cargo"],
  endpoints: (builder) => ({
    getCargos: builder.query({
      query: () => ({
        url: "/v1/api/cargo/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Cargo",
                id,
              })),
              { type: "Cargo", id: "LIST" },
            ]
          : [{ type: "Cargo", id: "LIST" }],
    }),
    getCargo: builder.query({
      query: (id) => ({
        url: `/v1/api/cargo/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Cargo", id }],
    }),
  }),
});

export const {
  useGetCargosQuery,
  useGetCargoQuery,
  useCreateCargoMutation,
  useUpdateCargoMutation,
  useDeleteCargoMutation,
} = cargoApi;
